import { render, staticRenderFns } from "./BindsTableEmptyState.vue?vue&type=template&id=12d0c4da&"
import script from "./BindsTableEmptyState.vue?vue&type=script&lang=js&"
export * from "./BindsTableEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./BindsTableEmptyState.vue?vue&type=style&index=0&id=12d0c4da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports